export interface RetryOptions {
  maxRetries?: number;
  retryDelay?: number;
  retryCondition?: (error: any) => boolean;
}

const defaultRetryOptions: Required<RetryOptions> = {
  maxRetries: 2,
  retryDelay: 1000,
  retryCondition: () => true,
};

export const retryNetworkRequest = async <T>(
  fn: () => Promise<T>,
  options: RetryOptions = {}
): Promise<T> => {
  const opts = { ...defaultRetryOptions, ...options };
  let lastError: any;

  for (let attempt = 0; attempt <= opts.maxRetries; attempt++) {
    try {
      return await fn();
    } catch (error: any) {
      lastError = error;

      if (attempt < opts.maxRetries && opts.retryCondition(error)) {
        await new Promise(resolve => setTimeout(resolve, opts.retryDelay * (attempt + 1)));
        continue;
      }

      throw error;
    }
  }

  throw lastError;
};

